import type { DefaultApiParams } from '@/std/pagination/types';
import { fetchApi } from '@/std/api/fetchApi';
import { registrosSchema } from '@/std/schema';
import { ProdutoNcmSchema } from '../types/ProdutoNcm';

type ApiProdutoNcmGetParams = DefaultApiParams & {
    pesquisar?: string;
};

const schema = registrosSchema(ProdutoNcmSchema);

export function apiProdutoNcmGet(params: ApiProdutoNcmGetParams) {
    return fetchApi({
        endpoint: 'ProdutoNcm/ProdutoNcm',
        method: 'get',
        params,
        schema,
    });
}
